module.exports = __webpack_public_path__ + "static/img/nine.7535831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/nine.png
// module id = kFod
// module chunks = 1